import fetchQueues from './getQueues';
import fetchQueueAgents from './getQueueAgents';
import logUserToDistgroup from './logUserToDistgroup';

const watchQueues = [fetchQueues, fetchQueueAgents, logUserToDistgroup];

export default watchQueues;
